import axios from "axios";
import Cookies from "js-cookie";
import { clearTokens, ACCESS_TOKEN_COOKIE } from "../auth/tokenHelpers";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

/**
 * Auth header matches buyer's `makeApiCall`: send the RAW cookie value
 * (the JSON-stringified token object) as Authorization — NOT `Bearer x`.
 * The gateway expects this exact format.
 */
api.interceptors.request.use((config) => {
  const raw = Cookies.get(ACCESS_TOKEN_COOKIE);
  if (raw) {
    config.headers = config.headers ?? {};
    config.headers["Authorization"] = raw;
  }
  // FormData → let browser set multipart boundary
  if (config.data instanceof FormData) {
    config.headers = config.headers ?? {};
    delete (config.headers as any)["Content-Type"];
  }
  return config;
});

// On 401 / Token Expired → clear and bounce to login.
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    const msg = err?.response?.data?.message;
    if (status === 401 || msg === "Token Expired") {
      clearTokens();
      if (window.location.pathname !== "/login") {
        const redirect = encodeURIComponent(
          window.location.pathname + window.location.search
        );
        window.location.href = `/login?redirect=${redirect}`;
      }
    }
    return Promise.reject(err);
  }
);

export default api;
